export default __webpack_public_path__ + "static/media/NTEX CLASS-6_SYLLABUS_2025-26.04104788.pdf";